import Vue from "vue";

export const getSelfFirstName = state => state.me.firstname;
export const getSelfBodyPrint = state => state.me.active_bodyprint;
export const getSelfId = state => state.me._id;
export const getSelfLastUpdated = state =>
  Vue.moment(state.me.last_updated_at).format("LLL");
export const getSelfMatch = state => state.match;
export const getSelfMatchStatus = state =>
  state.match ? state.match.STATUS : null;
export const getSelfMatchSize = state =>
  state.match ? state.match.SIZE : null;
export const getPasswordResetEmail = state =>
  state.match ? state.passwordReset.email : null;
export const getPasswordResetConfirmationCode = state =>
  state.passwordReset.confirmationCode;
